<div class="dl-navigation" [@navigationCollapse]="collapsed ? 'collapsed' : 'expanded'"
  (@navigationCollapse.start)="onNavAnimationEvent($event)" (@navigationCollapse.done)="onNavAnimationEvent($event)">
  <nav class="d-flex flex-nowrap flex-column nav">
    <a id="lnkNavHome" class="nav-link d-flex align-items-center" routerLink="/home" routerLinkActive="active"
      matTooltip="Home" [matTooltipDisabled]="!collapsed" [matTooltipPosition]="'right'">
      <div class="d-flex align-items-center justify-content-center dl-nav-icon-container">
        <mat-icon aria-hidden="false" aria-label="home">home</mat-icon>
      </div>
      <span class="ml-2" *ngIf="!hideMenuText">Home</span>
    </a>

    <a id="lnkNavDataCollections" class="nav-link d-flex align-items-center" routerLink="/data-collections"
      routerLinkActive="active" matTooltip="Data Collections" [matTooltipDisabled]="!collapsed"
      [matTooltipPosition]="'right'">
      <div class="d-flex align-items-center justify-content-center dl-nav-icon-container">
        <mat-icon aria-hidden="false" aria-label="library_books">library_books</mat-icon>
      </div>
      <span class="ml-2" *ngIf="!hideMenuText">Data Collections</span>
    </a>

    <a id="lnkNavDataUtilization" class="nav-link d-flex align-items-center" routerLink="/data-utilization"
      routerLinkActive="active" matTooltip="Data Utilization Request" [matTooltipDisabled]="!collapsed"
      [matTooltipPosition]="'right'">
      <div class="d-flex align-items-center justify-content-center dl-nav-icon-container">
        <mat-icon aria-hidden="false" aria-label="insights">insights</mat-icon>
      </div>
      <span class="ml-2" *ngIf="!hideMenuText">Data Utilization</span>
    </a>

    <a id="lnkNavProjectSpace" class="nav-link d-flex align-items-center" routerLink="/data-uploads"
      routerLinkActive="active" matTooltip="Data Uploads" [matTooltipDisabled]="!collapsed"
      [matTooltipPosition]="'right'">
      <div class="d-flex align-items-center justify-content-center dl-nav-icon-container">
        <mat-icon aria-hidden="false" aria-label="backup">backup</mat-icon>
      </div>
      <span class="ml-2" *ngIf="!hideMenuText">Data Uploads</span>
    </a>

    <a id="lnkNavVirtualEnv" class="nav-link d-flex align-items-center" routerLink="/virtual-env"
      routerLinkActive="active" matTooltip="Virtual Environment" [matTooltipDisabled]="!collapsed"
      [matTooltipPosition]="'right'">
      <div class="d-flex align-items-center justify-content-center dl-nav-icon-container">
        <mat-icon aria-hidden="false" aria-label="cast">cast</mat-icon>
      </div>
      <span class="ml-2" *ngIf="!hideMenuText">Virtual Environment</span>
    </a>

    <div class="mt-auto d-flex flex-row dl-collapse-button-container">
      <mat-icon aria-hidden="false" aria-label="chevron_left" class="dl-clickable" (click)="collapse()"
        [@imageRotate]="collapsed ? 'collapsed' : 'expanded'">chevron_left</mat-icon>
    </div>
  </nav>
</div>